import React from 'react'
import './CompareWarehouseList.css'
import { MdClose } from 'react-icons/md';
import Tooltip from 'react-bootstrap/Tooltip'
import {  OverlayTrigger } from 'react-bootstrap';
import CarouselList from '../Carousel/CarouselList'
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'
class CompareWarehouseList extends React.Component {
    onClickGoToWareHouseDetails(data) {
        // let name = data ? data.name.toLowerCase().replace(/[ `~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-') : ''
        // name = name + '-' + data.id
        // if (name !== undefined && name !== null && name !== "")
            window.open(window.location.origin + "/warehouse/" + data.warehouse_slug, "_blank")
        // window.location.assign("/warehouse/" + name, "_blank")
    }

    render() {
        let warehouse = this.props.warehouse;
        const { warehouse_capacity } = warehouse

        return (<>

            <div className="wh-section-list">
                <React.Fragment>
                    {['top'].map(placement => (
                        <OverlayTrigger
                            key={placement}
                            placement={placement}
                            overlay={
                                <Tooltip id={`tooltip-${placement}`}>
                                    <MultiLanguageTranslation title="Remove" />
                                </Tooltip>
                            }
                        >
                            <div onClick={() => this.props.onClickRemove(this.props.index)} className="whCompareDelete"><MdClose color="red" /></div>
                        </OverlayTrigger>
                    ))}
                </React.Fragment>
                {/* <img src={warehousecompare} /> */}
                <CarouselList warehousecontent={warehouse} sliderurl={warehouse.multimedia} whcart={true}></CarouselList>
                <h4>{warehouse.name}</h4>
                <div className="new-wh-detail">
                    <ul>
                        <li>
                            <strong><MultiLanguageTranslation title="Total Space Available" />: </strong>
                            <span>{warehouse.current_capacity_available} MT</span>
                        </li>
                       {<li>
                            <strong><MultiLanguageTranslation title="Expected Booking Price" />: </strong>
                            <span>{warehouse.expected_price ? ' ₹'+ parseFloat(warehouse.expected_price).toLocaleString('en-IN') +'/MT' : "N/A"}</span>
                        </li>}
                        <li>
                            <strong><MultiLanguageTranslation title="Commodity Suitable" />: </strong>
                            <span><MultiLanguageTranslation title="All" /></span>
                        </li>
                        {/* <li>
                            <strong><MultiLanguageTranslation title="Rent/MT" />: </strong>
                            <span>{warehouse_capacity.price_range_mt ? warehouse_capacity.price_range_mt : "N/A"}</span>
                        </li> */}
                    </ul>
                </div>
                <a href="#" onClick={() => this.onClickGoToWareHouseDetails(warehouse)}><MultiLanguageTranslation title="View more details" /></a>
            </div>
        </>
        );
    }
}

export default CompareWarehouseList;

